import { createContext } from 'react'

type ContextState = {
  [key: string]: any
}

export const TicTacToeContext = createContext({} as ContextState)

